import React, { Component } from 'react';
import './Cart.css';

import CartItem from './Cart--Item';
import CartShipping from './Cart--Shipping';
import CartDiscount from './Cart--Discount';

class Cart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cart:this.props.cart,
      shipping:this.props.shipping,
      store:this.props.store
    };

  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      cart:newProps.cart,
      shipping:newProps.shipping,
      store:newProps.store
    });

  }

  render() {
    
    var cartShipping  = "";
    if (this.state.cart && this.state.shipping) { // && this.state.cart.shipping_required) {  
      cartShipping = 
        <div>
          <label>Shipping</label>
          <div className="clearflex justify-flex-start">
            <CartShipping name="" price={0} shippingMessage={this.state.store.shipping_message} storeEmail={this.state.store.email} />
          </div>
        </div>
    }

    var cartDiscount  = "";
    if (this.state.cart) {  
      cartDiscount = 
        <div>
          <label>Discounts</label>
          <div className="clearflex justify-flex-start">
            <CartDiscount name={""} discount={0} code={""} store={this.state.store.permalink} clearDiscount={this._clearDiscount} />
          </div>
        </div>
    }

    return (
      <div>

        <div className="Cart clearfix">
            
            <label>Cart Items</label>
            <div className="clearflex justify-flex-start align-flex-start">
              {this.state.cart && this.state.cart.cart.length > 0 ?
                this.state.cart.cart.map((item, index) => (
                  <CartItem key={index} cart_item={item} updateCart={this.props.updateCart} store={this.state.store} />
                ))
              :
                <div className="Page cartRow">

                  <div className="cartRow-info clearflex align-flex-start">
                    <div className="two-thirds column">
                      <p>&nbsp;</p>
                    </div>
                    <div className="one-third column">
                      <p>{!this.state.cart ? "Getting cart..." : "None"}</p>
                    </div>
                  </div>

                </div>
              }
            </div>
            
           
            {cartDiscount}

            
            {cartShipping}
                      
        </div>
      </div>
    );  
  
  }

  _clearDiscount() {
    // later
  }

}

export default Cart;


// WEBPACK FOOTER //
// ./src/components/Cart.js